var React = require('react');

function CircleCutout (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .circle-cutout {\n      height: 100px;\n      width: 100px;\n      fill: none;\n      stroke-width: 4;\n      stroke-linecap: round;\n    }\n  "),React.createElement("path",{"d":"M95,50 A45,45 0 0,1 5,50 A45,45 0 0,1 50,5","key":1})]);
}

CircleCutout.defaultProps = {"className":"circle-cutout","viewBox":"0 0 100 100"};

module.exports = CircleCutout;

CircleCutout.default = CircleCutout;
